import { TClassValue } from "./cn.models";

/** Joins truthy class names. Keeps Tailwind class lists readable in JSX. */
export const cn = (...values: TClassValue[]): string =>
  values.filter(Boolean).join(" ");
